import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import { useDispatch, useSelector } from "react-redux";

import { addActor, selectActors } from "../../app/slices/TrainingSlice";
import ActorPresetList from "./ActorPresetList";
import "./ActorPresetsColumn.css";
import PiButton from "../../components/PiButton";
import { ActorHelper } from "./ActorHelper";

export default function ActorPresetsColumn() {
  const dispatch = useDispatch();
  const actors = useSelector(selectActors);
  const onAddNewActor = () => {
    dispatch(addActor(ActorHelper.GetNewRandomActor(actors)));
  };

  const addActorButton = (
    <div className="px-[18px] h-[40px]">
      <PiButton variant="piBlue" onClick={onAddNewActor}>
        <div
          className={"h-full flex justify-center mx-auto justify-items-center"}
        >
          <div className={"flex gap-[8px] my-auto text-[24px]"}>
            <PersonAddAltIcon className={""} fontSize={"inherit"} />
            <div className={"text-[14px] my-auto"}>Add Actor</div>
          </div>
        </div>
      </PiButton>
    </div>
  );

  return (
    <div className="flex flex-col gap-y-[10px] max-h-[100%]">
      <ActorPresetList />
      {addActorButton}
    </div>
  );
}
